import { render, staticRenderFns } from "./newbiegift.vue?vue&type=template&id=576409a8"
import script from "./newbiegift.vue?vue&type=script&lang=ts&setup=true"
export * from "./newbiegift.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./newbiegift.vue?vue&type=style&index=0&id=576409a8&prod&lang=less"
import style1 from "./newbiegift.vue?vue&type=style&index=1&id=576409a8&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports